<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "AGREGAR NUEVO" : "ACTUALIZAR" }} CLIENTE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- DATOS SHOW -->
        <div class="vx-row">
          <small>
            <div class="vx-col w-full">
              <p><span class="font-semibold">Cliente: </span>{{names_client | capitalize}} {{surnames_client | capitalize}}</p>
              <p><span class="font-semibold">Email: </span>{{email_user}}</p>
            </div>
          </small>
        </div>

        <!-- EMAIL -->
        <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input label="Nombres" v-model="names_client" class="mt-2 w-full" name="names_client" v-validate="'alpha_spaces'" />
                <span class="text-danger text-sm" v-show="errors.has('names_client')">{{ errors.first('names_client') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input label="Apellidos" v-model="surnames_client" class="mt-2 w-full" name="surnames_client" v-validate="'alpha_spaces'" />
                <span class="text-danger text-sm" v-show="errors.has('surnames_client')">{{ errors.first('surnames_client') }}</span>
            </div>
        </div>

        <!-- TELEFONOS -->
        <div class="vx-row px-4 mt-2">
          <div class="sm:w-1/3 w-full pr-1">
              <vs-input label="Telf Móvil" v-model="phone_mobile_client" placeholder="0584166889887" class="w-full" name="phone_mobile_client" v-validate="''" />
              <span class="text-danger text-sm" v-show="errors.has('phone_mobile_client')">{{ errors.first('phone_mobile_client') }}</span>
          </div>
          <div class="sm:w-1/3 w-full pr-1">
              <vs-input label="Telf Ofic" v-model="phone_office_client" placeholder="0584166889887" class="w-full" name="phone_office_client" v-validate="''" />
              <span class="text-danger text-sm" v-show="errors.has('phone_office_client')">{{ errors.first('phone_office_client') }}</span>
          </div>
          <div class="sm:w-1/3 w-full">
              <vs-input label="Telf Domicilio" v-model="landline_client" placeholder="0584166889887" class="w-full" name="landline_client" v-validate="''" />
              <span class="text-danger text-sm" v-show="errors.has('landline_client')">{{ errors.first('landline_client') }}</span>
          </div>
        </div>

        <!-- ADDRESS -->
        <div class="vx-row mt-2">
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input label="Dirección Domicilio" v-model="home_address_client" class="w-full" name="home_address_client" />
                <span class="text-danger text-sm" v-show="errors.has('home_address_client')">{{ errors.first('home_address_client') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
                <vs-input label="Dirección Oficina" v-model="office_address_client" class="w-full" name="office_address_client" />
                <span class="text-danger text-sm" v-show="errors.has('office_address_client')">{{ errors.first('office_address_client') }}</span>
            </div>
        </div>

        <!-- PAIS  -->
        <div class="vx-row mt-2">
          <div class="vx-col w-full">
            <label class="vs-input--label">País de procedencia <small>(donde se encuentra ahora mismo)</small></label>
            <v-select :closeOnSelect="true" v-model="id_country" label="name_country" :options="countries" name="id_country" :reduce="countries => countries.id_country" :clearable="false"></v-select>
          </div>
        </div>

        <!-- 1RA NACIONALIDAD  Y 2DA NACIONALIDAD-->
        <div class="vx-row mt-2">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">1ra Nacionalidad</label>
            <v-select :closeOnSelect="true" v-model="id_first_nationality" label="name_country" :options="countries" name="id_first_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">2da Nacionalidad</label>
            <v-select :closeOnSelect="true" v-model="id_second_nationality" label="name_country" :options="countries" name="id_second_nationality" :reduce="countries => countries.id_country" :clearable="false"></v-select>
          </div>
        </div>
     
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ingresar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id_client, names_client, surnames_client, email_user, phone_mobile_client, phone_office_client, landline_client, home_address_client, office_address_client, id_first_nationality, id_second_nationality, id_country } = JSON.parse(JSON.stringify(this.data))
        this.id_client = id_client
        this.names_client = names_client
        this.surnames_client = surnames_client
        this.email_user = email_user
        this.phone_mobile_client = phone_mobile_client
        this.phone_office_client = phone_office_client
        this.landline_client = landline_client
        this.home_address_client = home_address_client
        this.office_address_client = office_address_client
        this.id_first_nationality = id_first_nationality
        this.id_second_nationality = id_second_nationality
        this.id_country = id_country
        this.initValues()
      }
    }
  },
  data () {
    return {
      id_client: null,
      names_client: '',
      surnames_client: '',
      email_user: null,
      phone_mobile_client: '',
      phone_office_client: '',
      landline_client: '',
      home_address_client: '',
      office_address_client: '',
      id_first_nationality: '',
      id_second_nationality: '',
      id_country: '',

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    countries () {
      return this.$store.state.countries
    },
    nationalities () {
      return this.$store.state.nationalities
    },
    isFormValid () {
      return !this.errors.any() 
    }
  },
  methods: {
    initValues () {
      
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id_client: this.id_client,
            names: this.names_client,
            surnames: this.surnames_client,
            first_nationality_id: this.id_first_nationality,
            second_nationality_id: this.id_second_nationality,
            phone_office: this.phone_office_client,
            phone_mobile: this.phone_mobile_client,
            landline: this.landline_client,
            country_id: this.id_country,
            home_address: this.home_address_client,
            office_address: this.office_address_client
          }
          this.$vs.loading()
          if (this.$route.name === 'admin.clientes') {
            this.$store.dispatch('updateClientPerfil', obj)
              .then(() => { this.$emit('closeSidebarSuccess') })
              .then(() => { this.$vs.loading.close() })
              .then(() => {
                this.$vs.notify({
                  title: 'Cliente actualizado',
                  text: 'Ha sido actualizado un cliente del portal',
                  color: 'success',
                  iconPack: 'feather',
                  icon:'icon-check',
                  time: 4000
                }) 
              })
              .then(() => { this.initValues() })
              .catch(err => { 
                this.$vs.loading.close()
                // console.log(Object.getOwnPropertyNames(err))
                console.error(err)
                // console.log(err.response.data.errors)
                const mensaje_error = err.response.data.errors
                const array_errors = Object.entries(mensaje_error)

                for (let i = 0; i < array_errors.length; i++) {
                  this.$vs.notify({
                    title: 'Registro Fallido',
                    text: `${array_errors[i][1][0]}`,
                    iconPack: 'feather',
                    icon: 'icon-x-circle',
                    color: 'warning',
                    time: 6000
                  })
                }
              })
          } else this.$store.dispatch('updateClientPDN', obj)
            .then(() => { this.$emit('closeSidebarSuccess') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Cliente actualizado',
                text: 'Ha sido actualizado un cliente del portal',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check',
                time: 4000
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              console.error(err)
              const mensaje_error = err.response.data.errors
              const array_errors = Object.entries(mensaje_error)
              for (let i = 0; i < array_errors.length; i++) {
                this.$vs.notify({
                  title: 'Registro Fallido',
                  text: `${array_errors[i][1][0]}`,
                  iconPack: 'feather',
                  icon: 'icon-x-circle',
                  color: 'warning',
                  time: 6000
                })
              }
            })
          this.$emit('closeSidebar')
          // this.initValues()
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.demo-alignment {
  margin-top:-15px;
}
</style>
